import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '分类浏览',
    links: [
      { label: '平台推荐', path: '/category/platform-recommendation' },
      { label: '领取攻略', path: '/category/claim-guide' },
      { label: '提款条件', path: '/category/withdrawal-conditions' },
    ],
  },
  {
    title: '更多内容',
    links: [
      { label: '最新优惠', path: '/category/latest-promotions' },
      { label: '使用攻略', path: '/category/strategy-guide' },
      { label: '新手教程', path: '/category/newbie-tutorial' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-gift-line text-background-50 text-base"></i>
              </div>
              <span className="text-foreground-950 font-semibold text-lg">彩金攻略</span>
            </Link>
            <p className="text-foreground-600 text-sm leading-relaxed">
              致力于为新用户提供最新、最全面的注册送彩金优惠资讯。安全、可靠、值得信赖的信息平台。
            </p>
          </div>
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-foreground-950 font-medium text-sm mb-3">{group.title}</h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-foreground-600 hover:text-primary-500 text-sm transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 彩金攻略. 本站仅提供信息参考，不参与任何博彩经营活动。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-foreground-700 text-xs transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-500 hover:text-foreground-700 text-xs transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}